import * as Yup from "yup";

const champObligatoire = "Ce champ est obligatoire";
const champTypeError = "Mauvais type de données";
const champMail = "Adresse email valide requise";
const champTel = "Min 10 chiffres 0-9 sans espaces";
const min2Char = "Minimum 2 caractères";
const min10Char = "Minimum 10 caractères";
const pwdError = "Longueur 8 caractères, une majuscule, une minuscule, un chiffre";
const cpError = "Code postal de 5 digits";

const regexTel = /^[0-9+]*.{10,}$/;
const regexMFA = /^[0-9+]*.{6,}$/;
const regexMail = /(?:[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+(?:\.[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9\x2d]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
const regexPwd = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
const regexCodePostal = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/;

const today = new Date();
today.setHours(0, 0, 0, 0)

export const formConnexionClient = Yup.object().shape({
    mailClient: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champTypeError)
        .required(champMail),
    motDePasse: Yup
        .string()
        .typeError(champTypeError)
        .required(champObligatoire),
});

export const formCreerClient = Yup.object().shape({
    nomClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champTypeError)
        .required(champObligatoire),
    prenomClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champTypeError)
        .required(champObligatoire),
    mailClient: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champTypeError)
        .required(champMail),
    telClient: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champTypeError)
        .required(champObligatoire),
});

export const formMonCompteClient = Yup.object().shape({
    nomClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champTypeError)
        .required(champObligatoire),
    prenomClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champTypeError)
        .required(champObligatoire),
    mailClient: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champTypeError)
        .required(champMail),
    telClient: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champTypeError)
        .required(champObligatoire),
});

export const formMotDePasseClient = Yup.object().shape({
    motDePasse: Yup
        .string()
        .matches(regexPwd, pwdError)
        .typeError(champTypeError)
        .required(champObligatoire),
});

export const formContact = Yup.object().shape({
    nom: Yup
        .string()
        .min(2, min2Char)
        .typeError(champTypeError)
        .required(champObligatoire),
    prenom: Yup
        .string()
        .min(2, min2Char)
        .typeError(champTypeError)
        .required(champObligatoire),
    email: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champTypeError)
        .required(champMail),
    telephone: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champTypeError)
        .required(champObligatoire),
    message: Yup
        .string()
        .typeError(champTypeError)
        .required(champObligatoire),
});

export const nouveauRecruement = Yup.object().shape({
    nomIS: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    prenomIS: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    telephoneIS: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
});

export const formStructureCreer = Yup.object().shape({
    nomStructureClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    representantLegalStructureClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    representantLegalMailStructureClient: Yup
        .string()
        .matches(regexMail, champMail)
        .typeError(champObligatoire)
        .required(champObligatoire),
    representantLegalTelStructureClient: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
});

export const formStructureModifier = Yup.object().shape({
    nomStructureClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    representantLegalStructureClient: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    representantLegalMailStructureClient: Yup
        .string()
        .matches(regexMail, champMail)
        .typeError(champObligatoire)
        .required(champObligatoire),
    representantLegalTelStructureClient: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
});

export const formDemandeDPS1 = Yup.object().shape({
    orgaRaisonSociale: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaAdresse: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaRepresentantLegal: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaRepresentantLegalFonction: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaRepresentantLegalMail: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champObligatoire)
        .required(champMail),
    orgaRepresentantLegalTel: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaFacturationMail: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champObligatoire)
        .required(champMail),
    orgaRepresentePar: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaRepresenteParMail: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champObligatoire)
        .required(champMail),
    orgaRepresenteParTel: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaContactLocal: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaContactLocalTel: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
});
export const formDemandeDPS2 = Yup.object().shape({
    libelleEvenement: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    activiteEvenement: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    dateDebutEvenement: Yup
        .date()
        .min(today, "Ne peut être avant aujourd'hui")
        .typeError(champObligatoire)
        .required(champObligatoire),
    manifAdresse: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    manifCP: Yup
        .string()
        .matches(regexCodePostal, cpError)
        .typeError(champObligatoire)
        .required(cpError),
    manifVille: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    manifE1Accessibilite: Yup
        .number()
        .typeError(champObligatoire)
        .required(champObligatoire),
    manifE2DelaisSP: Yup
        .number()
        .typeError(champObligatoire)
        .required(champObligatoire),
});
const formDemandeDPS3OnePart = Yup.object().shape({
    dateDebutPartieEvenement: Yup
        .date()
        .typeError(champObligatoire)
        .required(champObligatoire),
    dateFinPartieEvenement: Yup
        .date()
        .test({
            name: 'ordre',
            exclusive: false,
            params: {},
            message: 'Fin avant le début',
            test: function (value) {
                return new Date(value) > new Date(this.parent.dateDebutPartieEvenement)
            },
        })
        .typeError(champObligatoire)
        .required(champObligatoire),
    
    dateDebutPartieSecours: Yup
        .date()
        .typeError(champObligatoire)
        .required(champObligatoire),
    dateFinPartieSecours: Yup
        .date()
        .test({
            name: 'ordre',
            exclusive: false,
            params: {},
            message: 'Fin avant le début',
            test: function (value) {
                return new Date(value) > new Date(this.parent.dateDebutPartieSecours)
            },
        })
        .typeError(champObligatoire)
        .required(champObligatoire),
    
    effectifPublicP1: Yup
        .number()
        .nullable(true)
        .test({
            name: "pubic présent",
            exclusive: false,
            params: {},
            message: "Public présent mais aucun effectif public renseigné",
            test: function (value) {
                if(this.parent.publicPresent)
                {
                    return value > 0
                }else{
                    return true
                }
            }
        }),
    typePublicP2: Yup
        .number()
        .nullable(true)
        .test({
            name: "pubic présent",
            exclusive: false,
            params: {},
            message: "Public présent mais comportement non-renseigné",
            test: function (value) {
                if(this.parent.publicPresent)
                {
                    return value > 0
                }else{
                    return true
                }
            }
        }),
    
    effectifActeurs: Yup
        .number()
        .nullable(true)
        .test({
            name: "acteurs présents",
            exclusive: false,
            params: {},
            message: "Acteurs présents mais aucun effectif acteur renseigné",
            test: function (value) {
                if(this.parent.acteurPresent)
                {
                    return value > 0
                }else{
                    return true
                }
            }
        }),
    
    activiteActeurs: Yup
        .string()
        .nullable(true)
        .test({
            name: "acteurs présents",
            exclusive: false,
            params: {},
            message: "Acteurs présents mais aucune activitée renseignée",
            test: function (value) {
                if(this.parent.acteurPresent)
                {
                    return value != null
                }else{
                    return true
                }
            }
        }),
});
export const formDemandeDPS3 = Yup.object().shape({
    parties: Yup
        .array().of(formDemandeDPS3OnePart)
        .min(1,"A minima une plage est nécessaire")
        .typeError(champObligatoire)
        .required(champObligatoire),
});
export const formDemandeDPS4 = Yup.object().shape({
});

export const formDemandeDPSLight1 = Yup.object().shape({
    orgaRaisonSociale: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaRepresentePar: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    orgaRepresenteParMail: Yup
        .string()
        .email(champMail)
        .matches(regexMail, champMail)
        .typeError(champObligatoire)
        .required(champMail),
    orgaRepresenteParTel: Yup
        .string()
        .matches(regexTel, champTel)
        .typeError(champObligatoire)
        .required(champObligatoire),
});
export const formDemandeDPSLight2 = Yup.object().shape({
    libelleEvenement: Yup
        .string()
        .min(2, min2Char)
        .typeError(champObligatoire)
        .required(champObligatoire),
    dateDebutEvenement: Yup
        .date()
        .min(today, "Ne peut être avant aujourd'hui")
        .typeError(champObligatoire)
        .required(champObligatoire),
    manifRemarques: Yup
        .string()
        .typeError(champObligatoire)
        .required(champObligatoire),
});

export const mfaInit = Yup.object().shape({
    confirmation: Yup
        .string()
        .typeError(champObligatoire)
        .required(champObligatoire)
        .length(6, "6 chiffres sont requis")
        .matches(regexMFA, "6 chiffres sont requis"),
});

export const requestDocToOrga = Yup.object().shape({});